export class ReplicatedTimeout {
    constructor(data, context, handedOff = false) {
        var _a;
        this.started = false;
        this.timeoutContext = context;
        this.data = Object.assign(Object.assign({}, data), { timestamp: (_a = data.timestamp) !== null && _a !== void 0 ? _a : Date.now() });
        if (!handedOff || context.isReady()) {
            this.start();
        }
    }
    start() {
        const elapsedTimeMs = Date.now() - this.data.timestamp;
        this.started = true;
        this.onStart();
        this.timeout = setTimeout(() => {
            this.callback();
            this.timeoutContext.onTimeoutDeleted();
        }, Math.max(0, this.data.durationMs - elapsedTimeMs));
    }
    cancel(remove = true) {
        clearTimeout(this.timeout);
        if (remove) {
            this.timeoutContext.onTimeoutDeleted();
        }
    }
    _registerDependency(dep) {
        this.timeoutContext.registerDependency(dep);
        if (!this.started && this.timeoutContext.isReady()) {
            this.start();
        }
    }
    _getContext() {
        return this.timeoutContext;
    }
    onStart() { }
}
//# sourceMappingURL=ReplicatedTimeout.js.map